import { setNotifications } from "store/actions/notificationsActions";
import { store } from "store/configureStore";
import { axiosApi } from "./helper";
import consola from "consola";

export function getNotifications() {
  return axiosApi("notifications", {}, "get");
}

export function seenNotification(id) {
  return axiosApi(`notifications/${id}/seen`, {}, "post");
}

export function refreshNotifications() {
  consola.info("Refreshing notifications");
  return new Promise((resolve, reject) => {
    getNotifications().then(
      (data) => {
        consola.success("Notifications refreshed");
        store.dispatch(setNotifications(data));
        resolve(data);
      },
      (error) => {
        reject(error);
      }
    );
  });
}
